import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=45d7b9c6&scoped=true&"
import script from "./Exam.vue?vue&type=script&lang=js&"
export * from "./Exam.vue?vue&type=script&lang=js&"
import style0 from "./Exam.vue?vue&type=style&index=0&id=45d7b9c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d7b9c6",
  null
  
)

export default component.exports